<template>
  <div class="frame-view">
    <the-header :isExpand="isExpand" @collapse="toggle"></the-header>
    <the-sider :isExpand="isExpand" :class="{ 'is-expand': isExpand }"></the-sider>
    <div class="main" :style="style" id='main-content'>
      <div class="path">
        <ul class="tabs">
          <li class="btn-prev" @click="prev">
            <i class="el-icon-arrow-left"></i>
          </li>
          <li class="pages" ref="pages">
            <div :class="{'cur': item.leafMenu.path === $route.path }" @click="chooseTab(item)" v-for="(item, index) in tabs" :key="index" class="tab">
              {{ item.leafMenu.name }}
              <span v-if="tabs.length > 1" @click.stop="delTab(index)" class="btn-del el-icon-close"></span>
            </div>
          </li>
          <li class="btn-next" @click="next">
            <i class="el-icon-arrow-right"></i>
          </li>
          <li class="btn-dropdown">
            <span class="text">页签操作</span>
            <i class="el-icon-caret-bottom"></i>
            <div class="btns">
              <div class="btn" @click="takeAction(1)">刷新当前</div>
              <div class="btn" @click="takeAction(2)">关闭当前</div>
              <div class="btn" @click="takeAction(3)">关闭其他</div>
              <div class="btn" @click="takeAction(4)">关闭全部</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="cur-router-msg">
        <breadcrumb></breadcrumb>
      </div> -->
      <div class="content">
        <keep-alive :max="10" :exclude="['OutsideView']">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TheHeader from './TheHeader'
import TheSider from './TheSider'
export default {
  name: 'FrameView',
  components: { TheHeader, TheSider },
  data () {
    return {
      isExpand: true,
      style: {
        left: '240px'
      },
      offset: 150
    }
  },
  computed: {
    ...mapState(['rootMenu', 'path', 'tabs', 'mainStyle'])
  },
  methods: {
    ...mapMutations(['removeTab', 'setRootMenu', 'setLeafMenu', 'setMainStyle', 'setTabs']),
    toggle () {
      this.isExpand = !this.isExpand
      this.style.left = (this.isExpand ? 240 : 64) + 'px'
      this.setMainStyle({
        top: this.mainStyle.top,
        bottom: this.mainStyle.bottom,
        left: this.style.left,
        right: this.mainStyle.right
      })
    },
    chooseTab (tab) {
      if (tab.leafMenu.path !== this.$route.path) {
        this.setRootMenu(tab.rootMenu)
        this.setLeafMenu(tab.leafMenu)
        this.$router.push(tab.leafMenu.path)
      }
    },
    delTab (index) {
      let nextTab = this.tabs[index + 1] || this.tabs[index - 1]
      this.removeTab(index)
      this.setRootMenu(nextTab.rootMenu)
      this.setLeafMenu(nextTab.leafMenu)
      this.$router.push(nextTab.leafMenu.path)
    },
    prev () {
      let el = this.$refs.pages
      if ((el.scrollLeft - this.offset) >= 0) {
        el.scrollLeft = el.scrollLeft - this.offset
      } else {
        el.scrollLeft = 0
      }
    },
    next () {
      let el = this.$refs.pages
      if ((el.scrollLeft + this.offset) <= el.scrollWidth) {
        el.scrollLeft = el.scrollLeft + this.offset
      } else {
        el.scrollLeft = 0
      }
    },
    takeAction (act) {
      let idx = this.tabs.findIndex(tab => tab.leafMenu.path === this.$route.path)
      let nextTab = null
      switch (act) {
        case 1:
          this.$router.go(0)
          break
        case 2:
          if (this.tabs.length > 1) {
            this.delTab(idx)
          }
          break
        case 3:
          this.setTabs([this.tabs[idx]])
          break
        case 4:
          nextTab = this.tabs[0]
          this.setTabs([nextTab])
          if (nextTab.leafMenu.path !== this.$route.path) {
            this.setRootMenu(nextTab.rootMenu)
            this.setLeafMenu(nextTab.leafMenu)
            this.$router.push(nextTab.leafMenu.path)
          }
          break
      }
    }
  },
  mounted () {
    this.setMainStyle(this.getStyle())
  }
}
</script>

<style lang="less" scoped>
.frame-view {
  width: 100%;
  height: 100%;
  position: relative;
  .the-sider {
    width: 64px;
    overflow: hidden;
    &.is-expand {
      width: 240px;
      overflow: auto;
    }
    transition: all 0.3s ease-out;
  }
  .main {
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 240px;
    right: 0;
    transition: all 0.3s ease-out;
    .path {
      display: flex;
      align-items: center;
      height: 36px;
      background-color: #f7f7f7;
      .tabs {
        width: 100%;
        height: 100%;
        display: flex;
        border-bottom: 1px solid #e6e6e6;
        .btn-prev, .btn-next, .btn-dropdown {
          display: flex;
          justify-content: center;
          align-items: center;
          padding:0 10px;
          font-size: 14px;
          color: #525252;
          background: #fff;
          cursor: pointer;
          border-left: 1px solid #e6e6e6;
        }
        .btn-prev {
          margin-left: 10px;
          width: 45px;
          border-right: 1px solid #e6e6e6;
        }
        .btn-next {
          width: 45px;
          margin-left: auto;
        }
        .btn-dropdown {
          color: #303133;
          position: relative;
          &:hover {
            .btns {
              display: block;
            }
          }
          .btns {
            display: none;
            position: absolute;
            top: 100%;
            left: -46px;
            right: 0;
            z-index: 1000;
            background: #fff;
            border-top: 1px solid #e6e6e6;
            border-left: 1px solid #e6e6e6;
            border-bottom: 1px solid #e6e6e6;
            .btn {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 8px;
              &:hover {
                color: #fff;
                background: #409EFF;
              }
            }
          }
        }
        .pages {
          height: 36px;
          flex: 1;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          &::-webkit-scrollbar {
            background: transparent;
            width: 0;
            height: 0;
          }
        }
        .tab {
          display: inline-block;
          align-items: center;
          height: 36px;
          line-height: 36px;
          border-bottom: 2px solid #e6e6e6;
          background: #f4f4f4;
          cursor: pointer;
          padding:0 10px;
          font-size: 14px;
          color: #525252;
          span {
            margin: 0 0 0 8px;
            padding: 1px;
            border-radius: 50%;
            &:hover {
              background:#cacaca;
              color: #fff;
            }
          }
          &.cur {
            background:#fff;
            border:1px solid #e6e6e6;
            border-bottom:1px solid #fff;
          }
        }
      }
      .icon {
        width: 18px;
        height: 18px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .content {
      position: absolute;
      top: 35px;
      bottom: 0;
      left: 0;
      right: 0;
      overflow-y: auto;
    }
    .cur-router-msg{
      padding: 15px;
      border-bottom: 1px solid #eee;
    }
  }
}
</style>